import jsApiList from "./jsApiList";
import {
  StorageSetParams,
  GeolocationGetParams,
  GeolocationResult,
  GeolocationStartParams,
  LocateMapParams,
  MapPOIResult,
  SearchMapParams,
  ViewMapParams,
  PickerParams,
  PickerResult,
  ContactPickerParams,
  UserInfo,
  DepartmentInfo
} from "./statement";
import { DateHelper, JsonHelper, ErrorType } from "@/common/Utils";
import FilterHelper from "@/common/Utils/FilterHelper";
import HttpService from "@/common/HttpService";

/**
 * DingTalk 钉钉容器调用
 */
export class DingTalk {
  static corpId = "";
  static appId = 0;
  /**
   * 初始化钉钉容器，配置jsApiList方可有权限使用其中的API
   */
  static async init(isConfig: boolean = true) {
    if (DingTalk.isDingTalk && window.location.search.length > 0) {
      let permissions: string[] = [];
      if (isConfig) {
        await DingTalk.config();
        let res = await DingTalk.login();
        let rights = res.rights || {}
        let right = ''
        for (let key in rights) {
          right = rights[key]
        }
        let rightArr = right.split('|')
        for (let index = 0; index < rightArr.length; index++) {
          const element = rightArr[index];
          element && permissions.push(element)
        }
        if (permissions.length <= 0) {
          window.baseConfig.development && alert(JsonHelper.toJson(res));
          let error = new Error('你没有权限访问访问该App，请联系管理员授权')
          error['success'] = false
          error['errorType'] = ErrorType.permissions
          throw error
        }
      }
      window.dd.ui.webViewBounce.disable();
      window.dd.biz.navigation.setRight({
        onSuccess: function(result) {},
        onFail: function(err) {}
      });
      return permissions;
    } else {
      return [];
    }
  }

  /**
   * JSAPI权限验证配置
   * 需要鉴权的JSAPI必须进行dd.config验证后才能调用
   */
  static async config() {
    try {
      if (DingTalk.isDingTalk && window.location.search.length > 0) {
        let corpid = window.location.search;
        corpid = corpid.substring(1).split("&", 1)[0];
        corpid = corpid.split("=")[1];
        DingTalk.corpId = corpid;
        let res = await HttpService.config2DingTalk(DingTalk.corpId);
        res["jsApiList"] = jsApiList;
        window.baseConfig.development && console.log(res);
        DingTalk.appId = parseInt(res.agentId, 0);
        window.dd.config(res);
        window.dd.error(error => {
          // rejct(error);
          window.baseConfig.development &&
            console.error("dd error: " + JsonHelper.toJson(error));
        });
        return true;
      } else {
        return false;
      }
    } catch (error) {
      throw error;
    }
  }

  static async login() {
    let res = await DingTalk.requestAuthCode();
    // if (res === false) return false
    let result = await HttpService.login2DingTalk(DingTalk.corpId, res.code);
    console.log(result);
    return result;
  }

  /**
   * 获取 DingTalk JSAPI实例对象
   * @param api JSAPI 名称
   */
  private static getApi(api: string) {
    return DingTalk._getObjectByApi(api.split(/\./g), window.dd);
  }

  /**
   * 遍历DingTalk JSAPI实例对象
   * @param api JSAPI 名称数组
   * @param object DingTalk 实例
   */
  private static _getObjectByApi(api: string[], object: any) {
    if (api.length > 0) {
      var o = api.shift() || "";
      var newObject = object[o];
      return DingTalk._getObjectByApi(api, newObject);
    }
    return object;
  }

  /**
   * 是否是钉钉容器
   */
  static get isDingTalk() {
    if (window.dd) {
      if (window.dd.version) {
        return true;
      }
    }
    return false;
  }

  /**
   * 执行DingTalk JSAPI实例对象并返回自定义类型{T}的Promise对象
   * @param api JSAPI 名称
   * @param params 参数
   * @param noDingTalk 在没有钉钉容器下要这些的操作
   */
  static execute<T = any>(
    api: string,
    params: any = null,
    noDingTalk = () => {}
  ) {
    return new Promise<T>((resolve, rejct) => {
      try {
        if (DingTalk.isDingTalk) {
          window.dd.ready(() => {
            if (params === null) {
              DingTalk.getApi(api)();
            } else {
              params.onSuccess = (result: T) => {
                if (params.handleSuccess) {
                  params.handleSuccess();
                } else {
                  resolve(result);
                }
              };
              params.onFail = err => {
                window.baseConfig.development &&
                  alert(api + "err: " + JsonHelper.toJson(err));
                rejct(err);
              };
              DingTalk.getApi(api)(params);
            }
          });
        } else {
          // resolve()
          noDingTalk();
          console.warn("请在钉钉容器调用接口:" + api);
        }
      } catch (error) {
        rejct(error);
      }
    });
  }

  /**
   * 获取微应用免登授权码
   */
  static requestAuthCode() {
    interface Result {
      /** 授权码，5分钟有效，且只能使用一次 */
      code: string;
    }
    return DingTalk.execute<Result>("runtime.permission.requestAuthCode", {
      corpId: DingTalk.corpId
    });
  }

  /**
   * 获取服务窗免登授权码
   */
  static requestChannelAuthCode() {
    interface Result {
      /** 授权码，5分钟有效，且只能使用一次 */
      code: string;
    }
    return DingTalk.execute<Result>("channel.permission.requestAuthCode");
  }

  /**
   * 获取微应用反馈式操作的临时授权码
   * @param agentId 微应用ID，必须与dd.config的一致
   */
  static requestOperateAuthCode(agentId: string) {
    interface Result {
      /** 授权码，5分钟有效，且只能使用一次 */
      code: string;
    }
    return DingTalk.execute<Result>(
      "runtime.permission.requestOperateAuthCode",
      { agentId }
    );
  }

  /**
   * 获取手机基础信息
   */
  static getPhoneInfo() {
    interface Result {
      /** 手机屏幕宽度 */
      screenWidth: number;
      /** 手机屏幕高度 */
      screenHeight: number;
      /** 手机品牌 */
      brand: string;
      /** 手机型号 */
      model: string;
      /** 版本 */
      version: string;
      /** 网络类型: wifi、2g、3g、4g、unknown、none，none表示离线 */
      netInfo: "wifi" | "4g" | "3g" | "2g" | "unknown" | "none";
      /** 运营商信息 */
      operatorType: string;
      /** 是否有SIM卡 */
      SIMCard: boolean;
    }
    return DingTalk.execute<Result>("device.base.getPhoneInfo");
  }

  /**
   * 设置存储信息
   * 每次存储数据不能超过1M,单域名不能超过50M.
   * @param params 参数
   */
  static setStorageItem(params: StorageSetParams) {
    return DingTalk.execute<{}>("util.domainStorage.setItem", params);
  }

  /**
   * 获取存储信息
   * @param name 存储信息的key值
   */
  static getStorageItem(name: string) {
    interface Result {
      /** name对应的存储信息 */
      value: string;
    }
    return DingTalk.execute<Result>("util.domainStorage.getItem", { name });
  }

  /**
   * 删除相应存储信息
   * @param name 存储信息的key值
   */
  static removeStorageItem(name: string) {
    return DingTalk.execute<{}>("util.domainStorage.removeItem", { name });
  }

  /**
   * 获取当前地理位置(单次定位)
   * Android客户端返回坐标是高德坐标，iOS客户端2.7.6及以后版本支持返回高德坐标；IOS客户端低于2.7.6版本仅支持返回标准坐标
   * 文档说明：https://open-doc.dingtalk.com/docs/doc.htm?spm=a219a.7629140.0.0.WSEhK7&treeId=171&articleId=104917&docType=1
   * 钉钉Android客户端2.1及之前版本返回的数据结构比iOS客户端多嵌套一层location字段，2.2及之后版本返回的数据结构与钉钉iOS客户端一致，建议对返回的数据先判断存在location，做向后兼容处理。
   * @param params 参数
   */
  static getGeolocation(params: GeolocationGetParams) {
    return DingTalk.execute<GeolocationResult>(
      "device.geolocation.get",
      params
    );
  }

  /**
   * 连续获取当前地理位置信息(持续定位)
   * 开始连续定位
   * @param params 参数
   */
  static startGeolocation(params: GeolocationStartParams) {
    return DingTalk.execute<GeolocationResult>(
      "device.geolocation.start",
      params
    );
  }

  /**
   * 停止连续定位
   * @param sceneId
   */
  static stopGeolocation(sceneId: string) {
    interface Result {
      /** 停止的定位场景id，当该场景没有开始定位时，返回null */
      sceneId: string | null;
    }
    return DingTalk.execute<Result>("device.geolocation.stop", { sceneId });
  }

  /**
   * 批量连续定位状态
   * @param sceneIds 需要查询定位场景id列表
   */
  static statusGeolocation(sceneIds: string[]) {
    /** 场景id以及对应的开启状态，1 表示正在持续定位， 0 表示未开始持续 */
    type Result = { [key: string]: 0 | 1 }[];
    return DingTalk.execute<Result>("device.geolocation.status", { sceneIds });
  }

  /**
   * 地图定位
   * 唤起地图页面，获取设备位置及设备附近的POI信息；若传入的合法经纬度则显示出入的位置信息及其附近的POI信息。
   * @param params 参数
   */
  static locateMap(params: LocateMapParams) {
    return DingTalk.execute<MapPOIResult>("biz.map.locate", params);
  }

  /**
   * POI搜索
   * 唤起地图页面，根据设备位置或者传入的经纬度搜索POI。
   * @param params 参数
   */
  static searchMap(params: SearchMapParams) {
    return DingTalk.execute<MapPOIResult>("biz.map.search", params);
  }

  /**
   * 展示位置
   * 唤起地图页面，展示传入的经纬度位置。
   * @param params 参数
   */
  static viewMap(params: ViewMapParams) {
    return DingTalk.execute<{}>("biz.map.view", params);
  }

  /**
   * 下拉控件
   * @param params 测试
   */
  static chosenPicker(params: PickerParams) {
    return DingTalk.execute<PickerResult>("biz.util.chosen", params);
  }

  /**
   * 日期选择器
   * 注意：format只支持android系统规范，即2015-03-31格式为yyyy-MM-dd
   * @param value 默认显示日期
   * @param format format只支持android系统规范，即2015-03-31格式为yyyy-MM-dd
   */
  static chosenDatePicker(
    value: string = DateHelper.format(new Date()),
    format = "yyyy-MM-dd"
  ) {
    interface Result {
      /** 返回选择的日期 */
      value: string;
    }
    return DingTalk.execute<Result>("biz.util.datepicker", { value, format });
  }

  static chosenContactPicker(params: ContactPickerParams) {
    interface Result {
      /** 选择人数 */
      selectedCount: number;
      /** 返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段 */
      users: UserInfo[];
      /** 返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数） */
      departments: DepartmentInfo[];
    }
    return DingTalk.execute<Result>("biz.contact.complexPicker", {
      corpId: DingTalk.corpId,
      ...params
    });
  }

  /**
   * alert
   * @param message 消息内容
   * @param title 弹窗标题
   * @param buttonName 按钮名称
   */
  static alert(
    message: string,
    title: string = "提示",
    buttonName: string = "好的"
  ) {
    return DingTalk.execute<{}>("device.notification.alert", {
      message,
      title,
      buttonName
    });
  }

  /**
   * confirm
   * @param message 消息内容
   * @param title 弹窗标题
   * @param buttonLabels 按钮名称
   */
  static confirm(
    message: string,
    title: string = "提示",
    buttonLabels: string[] = ["取消", "确定"]
  ) {
    interface Result {
      /** 被点击按钮的索引值，Number类型，从0开始 */
      buttonIndex: number;
    }
    return DingTalk.execute<Result>("device.notification.confirm", {
      message,
      title,
      buttonLabels
    });
  }

  /**
   * prompt
   *
   * 带输入框的confirm
   * @param message 消息内容
   * @param title 弹窗标题
   * @param buttonLabels 按钮名称
   */
  static prompt(
    message: string,
    title: string = "提示",
    buttonLabels: string[] = ["取消", "确定"],
    defaultText: string = ""
  ) {
    interface Result {
      /** 被点击按钮的索引值，Number类型，从0开始 */
      buttonIndex: number;
      /** 输入的值 */
      value: string;
    }
    return DingTalk.execute<Result>("device.notification.prompt", {
      message,
      title,
      defaultText,
      buttonLabels
    });
  }

  /**
   * vibrate 震动
   * @param duration 震动时间，android可配置 iOS忽略
   */
  static vibrate(duration = 300) {
    return DingTalk.execute<{}>("device.notification.vibrate", { duration });
  }

  /**
   * showPreloader
   *
   * 显示浮层，请和hidePreloader配对使用
   * @param text loading显示的字符，空表示不显示文字
   * @param showIcon 是否显示icon，默认true。Android无此参数。
   */
  static showPreloader(text = "使劲加载中..", showIcon = true) {
    return DingTalk.execute<{}>("device.notification.showPreloader", {
      text,
      showIcon
    });
  }

  /**
   * hidePreloader
   */
  static hidePreloader() {
    window.dd.device.notification.hidePreloader({
      onSuccess: function(result) {},
      onFail: function(err) {}
    });
  }

  /**
   * toast
   * @param text 提示信息
   * @param icon icon样式，有 success 和error，默认为空 0.0.2
   * @param duration 显示持续时间，单位秒，默认按系统规范[android只有两种(<=2s >2s)]
   * @param delay 延迟显示，单位秒，默认0
   */
  static toast(
    text: string,
    icon: boolean | null = null,
    duration = 2,
    delay = 0
  ) {
    let params = { text, duration, delay };
    icon && (params["icon"] = icon);
    return DingTalk.execute<{}>("device.notification.toast", params);
  }

  /**
   * 单选列表
   * @param otherButtons 其他按钮列表
   * @param title 标题
   * @param cancelButton 取消按钮文本
   */
  static actionsheet(
    otherButtons: string[],
    title: string = "",
    cancelButton = "取消"
  ) {
    interface Result {
      /** 被点击按钮的索引值，Number，从0开始, 取消按钮为-1 */
      buttonIndex: number;
    }
    return DingTalk.execute<Result>("device.notification.actionSheet", {
      otherButtons,
      title,
      cancelButton
    });
  }

  static openCall() {
    return DingTalk.execute<{}>("biz.util.open", { name: "call" });
  }

  static openFriendAdd() {
    return DingTalk.execute<{}>("biz.util.open", { name: "friendAdd" });
  }

  /**
   * 在新窗口上打开链接
   * @param url 要打开链接的地址
   */
  static openLink(url: string, params: object = {}) {
    url = FilterHelper.url2string(url, params);
    return DingTalk.execute<{}>("biz.util.openLink", { url }, () => {
      window.location.href = url;
    });
  }

  /**
   * 替换页面
   *
   * 使用新的页面替换当前页面，当前页面会被立即销毁，展示新页面，无动画。
   * @param url 新的页面链接
   */
  static replaceLink(url: string, params: object = {}) {
    url = FilterHelper.url2string(url, params);
    return DingTalk.execute<{}>("biz.navigation.replace", { url }, () => {
      window.location.href = url;
    });
  }

  /**
   * 关闭当前窗口
   *
   * 调用此接口可以关闭当前浏览器窗口
   */
  static closeCurrentWindow() {
    window.dd.biz.navigation.close({
      onSuccess: function(result) {},
      onFail: function(err) {}
    });
  }

  /**
   * 打开钉钉微应用
   * @param agentid 钉钉微应用Id
   */
  static openMicroApp(agentid: string) {
    return DingTalk.openLink(
      `dingtalk://dingtalkclient/action/switchtab?index=2&name=work&scene=1&corpid=${
        DingTalk.corpId
      }&agentid=${agentid}`
    );
  }

  /**
   * 打开应用内页面
   * @param url 内部页面名称
   * @param params 需要传递的参数
   */
  static open(url: string, params: object = {}) {
    return DingTalk.openLink(`${window.location.origin}/${url}.html`, params);
  }

  /**
   * 打开一个未知类型的链接，有可能是外部链接或内部页面
   * @param url 外部链接或内部页面名称
   * @param params 需要传递的参数
   */
  static openIfLink(url: string, params: object = {}) {
    let re = new RegExp("[a-zA-z]+://[^s]*");
    if (!re.test(url)) {
      url = `${window.location.origin}/${url}.html`;
    }
    return DingTalk.openLink(url, params);
  }

  /**
   * 跳转一个未知类型的链接，有可能是外部链接或内部页面
   * @param url 外部链接或内部页面名称
   * @param params 需要传递的参数
   */
  static pushIfLink(url: string, params: object = {}) {
    let re = new RegExp("[a-zA-z]+://[^s]*");
    if (!re.test(url)) {
      url = `${window.location.origin}/${url}.html`;
    }
    window.location.href = FilterHelper.url2string(url, params);
  }

  /**
   * 跳转应用内页面
   * @param url 内部页面名称
   * @param params 需要传递的参数
   */
  static push(url: string, params: object = {}) {
    window.location.href = FilterHelper.url2string(
      `${window.location.origin}/${url}.html`,
      params
    );
  }

  /**
   * 替换应用内页面
   * @param url 内部页面名称
   * @param params 需要传递的参数
   */
  static replace(url: string, params: object = {}) {
    return DingTalk.replaceLink(
      `${window.location.origin}/${url}.html`,
      params
    );
  }

  /**
   * 图片浏览器
   * 调用此api，将显示一个图片浏览器
   * @param urls 图片地址列表
   * @param current 当前显示的图片链接
   */
  static previewImage(urls: string[], current: string) {
    return DingTalk.execute<{}>("biz.util.previewImage", { urls, current });
  }

  /**
   * 设置当前页面的标题
   * @param title 控制标题文本，空字符串表示显示默认文本
   */
  static setTitle(title: string) {
    document.title = title;
    return DingTalk.execute<{}>("biz.navigation.setTitle", { title });
  }

  /**
   * 扫描条形码、二维码
   * @param type  type为qrCode(二维码)、barCode(条形码)、all(全部)。默认all，如果有qrCode、barCode扫描不出来，请修改type为all
   */
  static scan(type: string = "all") {
    return DingTalk.execute<{ text: string }>("biz.util.scan", { type });
  }

  /**
   * 设置左侧导航按钮
   *
   * 因为Android导航栏左侧显示的是标题（设置导航栏标题），所以此jsapi只支持iOS。
   * 如果想在Android设备上拦截返回按钮的行为，请参考事件回调
   * @param text
   * @param handleSuccess
   * @param control
   */
  static setLeft(text: string, handleSuccess, control: boolean = true) {
    let backbutton = e => {
      handleSuccess();
      document.removeEventListener("backbutton", backbutton);
      e.preventDefault();
    };
    document.addEventListener("backbutton", backbutton);
    return DingTalk.execute<{}>("biz.navigation.setLeft", {
      text,
      control,
      handleSuccess
    });
  }

  /**
   * 设置导航栏右侧单个按钮
   *
   * 调用jsapi-setRight可以设置导航栏最右侧按钮的文字，并且接收点击事件，
   * 只能设置文本按钮，需要设置按钮的icon请查看设置下面的导航栏右侧多个按钮 setMenu
   * @param text 控制显示文本，空字符串表示显示默认文本
   * @param control 是否控制点击事件，true 控制，false 不控制， 默认true
   * @param show 控制按钮显示， true 显示， false 隐藏， 默认true
   */
  static setRight(
    text: string,
    handleSuccess,
    control: boolean = true,
    show: boolean = true
  ) {
    return DingTalk.execute<{}>("biz.navigation.setRight", {
      text,
      control,
      show,
      handleSuccess
    });
  }

  /**
   * 启用下拉刷新
   */
  static enablePullToRefresh() {
    return DingTalk.execute<{}>("ui.pullToRefresh.enable");
  }

  /**
   * 收起下拉loading
   */
  static stopPullToRefresh() {
    window.dd.ui.pullToRefresh.stop();
  }
}



// WEBPACK FOOTER //
// ./src/common/DingTalk/index.ts